export const SUPPORTED_LOCALES = ['sv', 'en'];
export const DEFAULT_LOCALE = 'sv';
